// src/pages/About.js
import React, { useEffect, useRef, useState } from "react";
import Odometer from "odometer";
import "odometer/themes/odometer-theme-default.css";
import Header from "../Componets/Header";
import CounterSection from "../Componets/CounterSection";
import Footer from "../Componets/Footer";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import ScrollReveal from "scrollreveal";

const About = () => {
  const [loading, setLoading] = useState(true);
  const [current, setCurrent] = useState(0); //images silder
  const counterRef = useRef(null);

  useEffect(() => {
    if (counterRef.current) {
      const od = new Odometer({
        el: counterRef.current,
        value: 0,
        format: "d",
        duration: 2000,
      });

      od.update(15);
    }
  }, []);
  // Preloader timer
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    ScrollReveal().reveal(".scroll_reveal", {
      origin: "left",
      distance: "50px",
      duration: 2000,
      easing: "ease-in-out",
      reset: false,
      interval: 100,
    });
  }, []);
  //images silder

  const aboutImages = [
    "/assets/images/pristine_product_photos/Tools_5.png",
    "/assets/images/pristine_product_photos/Tools_6.png",
    "/assets/images/pristine_product_photos/Tools_8.png",
    "/assets/images/pristine_product_photos/Tools_10.png",
    "/assets/images/pristine_product_photos/Tools_11.png",
    "/assets/images/pristine_product_photos/Tools_12.png",
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % aboutImages.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {loading && (
        <div id="pre-load">
          <div id="loader" className="loader">
            <div className="loader-container">
              <div className="loader-icon">
                <img src="/assets/images/favicon.png" alt="Loader" />
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="rs-smoother-yes rtl">
        <div id="rs-mouse">
          <div id="cursor-ball"></div>
        </div>
        <Header />
        <Helmet>
          <title>
            {`About Us | ${process.env.REACT_APP_COMPANYNAME} | ${process.env.REACT_APP_PHONE1}`}
          </title>

          <meta
            name="description"
            content="Learn more about Pristine Precision Tools, a manufacturer of high-precision cutting tools for CNC & VMC machining applications."
          />

          <link
            rel="canonical"
            href={`${process.env.REACT_APP_SITE_URL}/about`}
          />

          <meta
            property="og:url"
            content={`${process.env.REACT_APP_SITE_URL}/about`}
          />

          <meta
            property="og:title"
            content={`About Pristine Precision Tools | CNC & VMC Cutting Tools`}
          />

          <meta
            property="og:description"
            content="Learn more about Pristine Precision Tools, a trusted manufacturer of CNC & VMC cutting tools."
          />

          <meta property="og:type" content="website" />
        </Helmet>
        {/* Banner Section */}
        <section className="inner-page-banner">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <nav aria-label="breadcrumb ">
                  <ol className="breadcrumb justify-content-center">
                    <li className="breadcrumb-item">
                      <Link to="/" title="pristine precision tools home page">
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      About Us
                    </li>
                  </ol>
                </nav>
                <div className="title text-white text-center">
                  <h1 className="text-white">About Us</h1>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- about area start --> */}
        <section className="rs-about-area section-space rs-about-four">
          <div className="container">
            <div className="row g-5">
              <div className="col-xl-6 col-lg-6">
                <div className="custom-product-card">
                  {/* --- Ribbon (Same as before) --- */}
                  <div className="ribbon-wrapper">
                    <div className="ribbon-content">
                      <div className="ribbon-number">
                        <span ref={counterRef} data-count="15">
                          15
                        </span>
                        <span className="plus-sign">+</span>
                      </div>
                      <span className="ribbon-text">Years Experience</span>
                    </div>
                  </div>

                  {/* --- SLIDER WINDOW (Mask) --- */}
                  <div className="slider-window">
                    {/* --- MOVING TRACK (Train of Images) --- */}
                    {/* Aa track 'current' index na hisabe left-right move thase */}
                    <div
                      className="slider-track"
                      style={{ transform: `translateX(-${current * 100}%)` }}
                    >
                      {aboutImages.map((imgSrc, index) => (
                        <div key={index} className="slide-item">
                          <img
                            src={imgSrc}
                            alt={`Slide ${index}`}
                            className="custom-slider-img"
                          />
                        </div>
                      ))}
                    </div>

                    {/* --- Dots (Controls) --- */}
                    <div className="custom-dots-wrapper">
                      {aboutImages.map((_, index) => (
                        <span
                          key={index}
                          className={`custom-dot ${
                            current === index ? "active" : ""
                          }`}
                          onClick={() => setCurrent(index)}
                        ></span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xl-6 col-lg-6">
                <div className="rs-about-wrapper">
                  <div className="rs-about-content-wrapper">
                    <div className="rs-section-title-wrapper">
                      <span className="rs-section-subtitle has-bg-field justify-content-start">
                        About Us
                      </span>
                      <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                        Precision Cutting Tools Solutions
                      </h2>
                      <p className="descrip">
                        At Pristine Precision Tools, we create advanced cutting
                        solutions that support efficient and accurate machining.
                        Our drilling and carbide tools are built to perform
                        reliably in demanding industrial environments.
                      </p>
                    </div>

                    {/* Tabs */}
                    <div className="rs-about-tab">
                      <ul
                        className="nav nav-pills"
                        id="about-pills-tab"
                        role="tablist"
                      >
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link active"
                            id="about-pills-item-one-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#about-pills-item-one"
                            type="button"
                            role="tab"
                            aria-controls="about-pills-item-one"
                            aria-selected="true"
                          >
                            Our History
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link"
                            id="about-pills-item-two-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#about-pills-item-two"
                            type="button"
                            role="tab"
                            aria-controls="about-pills-item-two"
                            aria-selected="false"
                          >
                            Our Mission
                          </button>
                        </li>
                        <li className="nav-item" role="presentation">
                          <button
                            className="nav-link"
                            id="about-pills-item-three-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#about-pills-item-three"
                            type="button"
                            role="tab"
                            aria-controls="about-pills-item-three"
                            aria-selected="false"
                          >
                            Our Vision
                          </button>
                        </li>
                      </ul>
                    </div>

                    <div className="rs-aobut-tab-content-wrapper">
                      <div
                        className="tab-content rs-about-tab-anim"
                        id="about-pills-tabContent"
                      >
                        <div
                          className="tab-pane fade show active"
                          id="about-pills-item-one"
                          role="tabpanel"
                          aria-labelledby="about-pills-item-one-tab"
                          tabIndex="0"
                        >
                          <div className="rs-about-tab-content">
                            <p>
                              Pristine Precision Tools was established to meet
                              the growing demand for reliable and high-precision
                              cutting tools. Over the years, we have
                              strengthened our capabilities through advanced
                              manufacturing processes and continuous
                              improvement.
                            </p>
                            {/* <div className="rs-about-feature-list">
                              <div className="rs-list-item has-theme-red">
                                <ul>
                                  <li>
                                    <i className="fa-regular fa-check"></i>{" "}
                                    Quality Control System
                                  </li>
                                  <li>
                                    <i className="fa-regular fa-check"></i>{" "}
                                    Building Quality Industrial
                                  </li>
                                </ul>
                              </div>
                            </div> */}
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="about-pills-item-two"
                          role="tabpanel"
                          aria-labelledby="about-pills-item-two-tab"
                          tabIndex="0"
                        >
                          <div className="rs-about-tab-content">
                            <p>
                              To manufacture high-quality precision cutting
                              tools that improve machining efficiency, accuracy,
                              and productivity while meeting customer-specific
                              requirements.
                            </p>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="about-pills-item-three"
                          role="tabpanel"
                          aria-labelledby="about-pills-item-three-tab"
                          tabIndex="0"
                        >
                          <div className="rs-about-tab-content">
                            <p>
                              To become a trusted global partner in precision
                              tooling by delivering consistent quality,
                              technical reliability, and performance-driven
                              solutions.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <!-- about area end --> */}
        {/* History Section */}
        {/* <section className="rs-history-area section-space rs-history-one">
          <div
            className="rs-history-bg-thumb"
            style={{
              backgroundImage: `url("/assets/images/bg/tab-bg-01.png")`,
            }}
          ></div>

          <div className="container">
            <div className="row g-5 justify-content-center section-title-space align-items-center">
              <div className="col-xxl-6 col-xl-6 col-lg-6">
                <div className="rs-section-title-wrapper text-center">
                  <span className="rs-section-subtitle has-theme-orange">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="11"
                      height="15"
                      viewBox="0 0 11 15"
                      fill="none"
                    >
                      <path
                        d="M3.14286 10L0 15L8.78104e-07 0L3.14286 5V10Z"
                        fill="#EA5501"
                      ></path>
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M6.28571 10L3.14286 15L3.14286 10L4.71428 7.5L3.14286 5L3.14286 0L6.28571 5L6.28571 10ZM6.28571 10L7.85714 7.5L6.28571 5V0L11 7.5L6.28571 15V10Z"
                        fill="#EA5501"
                      ></path>
                    </svg>
                    Our History
                  </span>
                  <h2 className="rs-section-title rs-split-text-enable split-in-fade">
                    Company Journey
                  </h2>
                </div>
              </div>
            </div>

            <div className="row justify-content-center">
              <div className="col-xxl-9 col-xl-10">
                <div className="rs-history-tab-wrapper">
                  Tabs commnet
                  <div className="rs-history-tab">
                    <ul
                      className="nav nav-pills"
                      id="history-pills-tab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="history-pills-item-one-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#history-pills-item-one"
                          type="button"
                          role="tab"
                          aria-controls="history-pills-item-one"
                          aria-selected="true"
                        >
                          In 1990
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="history-pills-item-two-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#history-pills-item-two"
                          type="button"
                          role="tab"
                          aria-controls="history-pills-item-two"
                          aria-selected="false"
                        >
                          In 2000
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="history-pills-item-three-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#history-pills-item-three"
                          type="button"
                          role="tab"
                          aria-controls="history-pills-item-three"
                          aria-selected="false"
                        >
                          In 2007
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="history-pills-item-four-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#history-pills-item-four"
                          type="button"
                          role="tab"
                          aria-controls="history-pills-item-four"
                          aria-selected="false"
                        >
                          In 2018
                        </button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link"
                          id="history-pills-item-five-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#history-pills-item-five"
                          type="button"
                          role="tab"
                          aria-controls="history-pills-item-five"
                          aria-selected="false"
                        >
                          In 2024
                        </button>
                      </li>
                    </ul>
                  </div>

                  Tab Content comment
                  <div className="rs-history-tab-content-wrapper">
                    <div
                      className="tab-content rs-history-tab-anim"
                      id="history-pills-tabContent"
                    >
                      Tab 1 comment
                      <div
                        className="tab-pane fade show active"
                        id="history-pills-item-one"
                        role="tabpanel"
                        aria-labelledby="history-pills-item-one-tab"
                        tabIndex="0"
                      >
                        <div className="rs-history-tab-item">
                          <div className="rs-history-tab-thumb">
                            <img
                              src="assets/images/history/history-thumb-01.png"
                              alt="history-image"
                            />
                          </div>
                          <div class="rs-history-tab-content">
                            <h5 class="rs-history-tab-title">
                              Journey Was Started
                            </h5>
                            <p>
                              Welcome to Industrie, a leading industry innovator
                              with a rich history of excellence. With a passion
                              for precision and a commitment to quality, we have
                              been empowering industries and driving progress.{" "}
                            </p>
                            <div class="rs-history-tab-list">
                              <div class="rs-list-item">
                                <ul>
                                  <li>Quality Control System</li>
                                  <li>Building Quality Industrial</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      Tab 2 comment
                      <div
                        className="tab-pane fade"
                        id="history-pills-item-two"
                        role="tabpanel"
                        aria-labelledby="history-pills-item-two-tab"
                        tabIndex="0"
                      >
                        <div className="rs-history-tab-item">
                          <div className="rs-history-tab-thumb">
                            <img
                              src="assets/images/history/history-thumb-02.png"
                              alt="history-image"
                            />
                          </div>
                          <div class="rs-history-tab-content">
                            <h5 class="rs-history-tab-title">
                              Journey Was Started
                            </h5>
                            <p>
                              Welcome to Industrie, a leading industry innovator
                              with a rich history of excellence. With a passion
                              for precision and a commitment to quality, we have
                              been empowering industries and driving progress.{" "}
                            </p>
                            <div class="rs-history-tab-list">
                              <div class="rs-list-item">
                                <ul>
                                  <li>Quality Control System</li>
                                  <li>Building Quality Industrial</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      Tab 3 comment
                      <div
                        className="tab-pane fade"
                        id="history-pills-item-three"
                        role="tabpanel"
                        aria-labelledby="history-pills-item-three-tab"
                        tabIndex="0"
                      >
                        <div className="rs-history-tab-item">
                          <div className="rs-history-tab-thumb">
                            <img
                              src="assets/images/history/history-thumb-03.png"
                              alt="history-image"
                            />
                          </div>
                          <div class="rs-history-tab-content">
                            <h5 class="rs-history-tab-title">
                              Journey Was Started
                            </h5>
                            <p>
                              Welcome to Industrie, a leading industry innovator
                              with a rich history of excellence. With a passion
                              for precision and a commitment to quality, we have
                              been empowering industries and driving progress.{" "}
                            </p>
                            <div class="rs-history-tab-list">
                              <div class="rs-list-item">
                                <ul>
                                  <li>Quality Control System</li>
                                  <li>Building Quality Industrial</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      Tab 4 comment
                      <div
                        className="tab-pane fade"
                        id="history-pills-item-four"
                        role="tabpanel"
                        aria-labelledby="history-pills-item-four-tab"
                        tabIndex="0"
                      >
                        <div className="rs-history-tab-item">
                          <div className="rs-history-tab-thumb">
                            <img
                              src="assets/images/history/history-thumb-04.png"
                              alt="history-image"
                            />
                          </div>
                          <div class="rs-history-tab-content">
                            <h5 class="rs-history-tab-title">
                              Journey Was Started
                            </h5>
                            <p>
                              Welcome to Industrie, a leading industry innovator
                              with a rich history of excellence. With a passion
                              for precision and a commitment to quality, we have
                              been empowering industries and driving progress.{" "}
                            </p>
                            <div class="rs-history-tab-list">
                              <div class="rs-list-item">
                                <ul>
                                  <li>Quality Control System</li>
                                  <li>Building Quality Industrial</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      Tab 5 comment
                      <div
                        className="tab-pane fade"
                        id="history-pills-item-five"
                        role="tabpanel"
                        aria-labelledby="history-pills-item-five-tab"
                        tabIndex="0"
                      >
                        <div className="rs-history-tab-item">
                          <div className="rs-history-tab-thumb">
                            <img
                              src="assets/images/history/history-thumb-05.png"
                              alt="history-image"
                            />
                          </div>
                          <div class="rs-history-tab-content">
                            <h5 class="rs-history-tab-title">
                              Journey Was Started
                            </h5>
                            <p>
                              Welcome to Industrie, a leading industry innovator
                              with a rich history of excellence. With a passion
                              for precision and a commitment to quality, we have
                              been empowering industries and driving progress.{" "}
                            </p>
                            <div class="rs-history-tab-list">
                              <div class="rs-list-item">
                                <ul>
                                  <li>Quality Control System</li>
                                  <li>Building Quality Industrial</li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  End Tab Content comment
                </div>
              </div>
            </div>
          </div>
        </section> */}
        \{/* footer start */}
        <Footer />
        {/* footer end */}
        {/* Backtotop start  */}
        <div className="backtotop-wrap cursor-pointer has-theme-red">
          <svg
            className="backtotop-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98" />
          </svg>
        </div>
        {/* <!-- Backtotop end --> */}
      </div>
      {/* )} */}
    </>
  );
};

export default About;
